import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { WelcomeTour } from "./WelcomeTour";
import { CheckCircle } from "lucide-react";

export function AdminOnboarding() {
  const navigate = useNavigate();
  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    const hasSeenAdminTour = localStorage.getItem("hasSeenAdminTour");
    if (!hasSeenAdminTour) {
      setShowTour(true);
    }
  }, []);

  const steps = [
    {
      title: "Welcome to HTICU Admin Portal",
      description: "You have full access to manage applications, users, and system settings. Let's take a quick tour of the key features.",
    },
    {
      title: "Applications Dashboard",
      description: "Monitor all applications from lead to enrollment. Use filters to find specific applications, and bulk actions to update multiple at once.",
      action: {
        label: "View Applications",
        onClick: () => {
          navigate("/admin/applications");
          setShowTour(false);
        },
      },
    },
    {
      title: "Analytics & Reporting",
      description: "Track conversion metrics, advisor performance, and enrollment trends. Export data for deeper analysis.",
      action: {
        label: "View Analytics",
        onClick: () => {
          navigate("/admin/analytics");
          setShowTour(false);
        },
      },
    },
    {
      title: "Automation & Integrations",
      description: "Configure automation rules, connect Zapier webhooks, and manage payment integrations in Settings.",
      action: {
        label: "Open Settings",
        onClick: () => {
          navigate("/admin/settings");
          setShowTour(false);
        },
      },
    },
    {
      title: "You're All Set!",
      description: "You now have everything you need to manage the admissions process efficiently. Check the Documentation tab in Settings for detailed guides.",
    },
  ];

  const handleComplete = () => {
    localStorage.setItem("hasSeenAdminTour", "true");
    setShowTour(false);
  };

  if (!showTour) return null;

  return <WelcomeTour steps={steps} onComplete={handleComplete} />;
}
